import { Button } from '@/components/ui/button'
import { X } from 'lucide-react'
import { cn } from '@/lib/utils'

interface XButtonProps {
  onClick: () => void
  size?: 'icon' | 'default' | 'sm' | 'lg'
  variant?: 'ghost' | 'primary' | 'outline'
  className?: string
  'aria-label'?: string
}

export default function XButton({
  onClick,
  size = 'icon',
  variant = 'ghost',
  className,
  'aria-label': ariaLabel = 'Close',
  ...props
}: XButtonProps) {
  return (
    <Button
      onClick={onClick}
      size={size}
      variant={variant}
      className={cn(
        'p-1.5 sm:p-2 hover:text-red-500 dark:hover:text-red-400 btn-red-glow transition-colors',
        className,
      )}
      aria-label={ariaLabel}
      {...props}
    >
      <X className="w-4 h-4" />
    </Button>
  )
}
